import React from 'react';
import { Frame, SageClassnames } from '@kajabi/sage-react';

import { useUiResourceContext, useResultContext } from 'common/components/CopyMagic/contexts';
import NullState from 'common/components/CopyMagic/components/NullState';

import HeadlineInput from '../HeadlineInput';
import SubheadlineInput from '../SubheadlineInput';

const topFrameClassNames = [SageClassnames.SPACERS.SM_TOP, SageClassnames.SPACERS.SM_BOTTOM].join(
  ' ',
);

const ResultDisplay = () => {
  const { loading, error } = useUiResourceContext();
  const { result } = useResultContext();

  if (loading || error) return null;
  if (!result)
    return (
      <NullState
        helpArticleLinkText="Topic suggestions"
        helpArticleLink="https://help.kajabi.com/hc/en-us/articles/13125455632411"
      />
    );

  return (
    <div>
      <Frame
        align={Frame.ALIGNMENTS.CENTER_SPREAD}
        direction={Frame.DIRECTIONS.HORIZONTAL}
        width={Frame.WIDTHS.FILL}
        className={topFrameClassNames}
      >
        <h3 className={`${SageClassnames.TYPE.BODY_SEMI}`}>Headline</h3>
      </Frame>
      <HeadlineInput />
      <Frame
        align={Frame.ALIGNMENTS.CENTER_SPREAD}
        direction={Frame.DIRECTIONS.HORIZONTAL}
        width={Frame.WIDTHS.FILL}
        className={topFrameClassNames}
      >
        <h3 className={`${SageClassnames.TYPE.BODY_SEMI}`}>Supporting copy</h3>
      </Frame>
      <SubheadlineInput />
    </div>
  );
};

export default ResultDisplay;
